// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"013249a0","171":"56f54811"}[chunkId] + ".chunk.js";
};